/* ==========================================================================
   HOME INTRO VIDEO — click-to-play facade for the "Who We Are" band on "/".
   Rendered by snippets/home-intro.liquid.

   Nothing is requested from youtube.com or ytimg.com until someone asks for
   the film: what ships in the HTML is a poster served from theme assets and a
   real <button>. The first activation replaces the stage with the player
   iframe, already carrying autoplay=1 so the click that asked for the video is
   the click that starts it. There is no autoplay before that click and no
   player code on the page before it either.

   The same delegated-click shape as assets/penguin-video.js, kept as a
   separate file because that one is loaded only by the product template and
   is bound to the .pdp-video__facade selector.
   ========================================================================== */
(function () {
  'use strict';

  var FACADE = '.home-intro__facade';

  function play(button) {
    var src = button.getAttribute('data-video-src');
    var stage = button.parentNode;
    if (!src || !stage) return;

    var frame = document.createElement('iframe');
    frame.className = 'home-intro__frame';
    frame.src = src;
    /* A player with no accessible name is an unlabelled application region to
       a screen reader. Same title the button announced. */
    frame.title = button.getAttribute('data-video-title') || 'Video';
    /* The permission list YouTube's own oEmbed response ships with. */
    frame.setAttribute(
      'allow',
      'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
    );
    frame.setAttribute('allowfullscreen', 'allowfullscreen');
    frame.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
    frame.setAttribute('frameborder', '0');

    stage.innerHTML = '';
    stage.appendChild(frame);

    /* Keyboard continuity: the control that was focused has just been removed
       from the document, so focus has to be put somewhere deliberate or it
       falls back to <body> and the user loses their place. */
    frame.setAttribute('tabindex', '-1');
    try { frame.focus({ preventScroll: true }); } catch (e) { frame.focus(); }
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;
    var button = target.closest(FACADE);
    if (!button) return;
    event.preventDefault();
    play(button);
  });
})();
